import React, { useEffect } from 'react';
import { Box, Typography, Stack, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const HubLandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <Box sx={{ mt: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Agent Web Portal
      </Typography>

      <Stack spacing={3} direction="column" alignItems="center" sx={{ width: '100%', maxWidth: 400 }}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          sx={{ height: 80, fontSize: '1.25rem' }}
          onClick={() => handleNavigate('/TransferBond')}
        >
          Transfer Bonds
        </Button>

        <Button
          variant="outlined"
          color="primary"
          size="large"
          fullWidth
          sx={{ height: 80, fontSize: '1.25rem' }}
          onClick={() => handleNavigate('/LargeBond')}
        >
          Large Bonds
        </Button>
      </Stack>
    </Box>
  );
};

export default HubLandingPage;
